import { useCommitmentEventSelectionContext } from '../components/commitmentEvents/commitmentEventSelectionContext'

// This function is used to check if the ParticipantContext has unappliedCommands active
export const useActiveUnappliedCommands = () => {
  const { current, previous } = useCommitmentEventSelectionContext()

  return (
    current?.type === 'unappliedCommand' ||
    previous?.type === 'unappliedCommand'
  )
}
